import React, { useEffect, useRef, useState } from "react"

import { useSelector } from "react-redux"
import { FILTER_TYPE } from "../../util/filters/filterConstants"
import { FilterManager } from "../../util/filters/filterManager"
import CustomTableContainer from "../Common/Table/CustomTableContainer"
import UserConfigModel from "./modals/userConfig"

export default function UserAccounts() {
  const [processedUsers, setProcessedUsers] = useState([])
  const usersData = useSelector((state) => state.internal.users)
  const [modalData, setModalData] = useState({ open: false })

  const filterManagerRef = useRef(null)
  if (!filterManagerRef.current) {
    filterManagerRef.current = FilterManager.Builder.addFilter(FILTER_TYPE.USER.ID, true)
      .addFilter(FILTER_TYPE.USER.EMAIL, true)
      .addFilter(FILTER_TYPE.USER.USERNAME, false)
      .addFilter(FILTER_TYPE.USER.FIRST_NAME, true)
      .addFilter(FILTER_TYPE.USER.LAST_NAME, true)
      .addFilter(FILTER_TYPE.USER.PHONE_NUMBER, false)
      .build()
  }
  const filterManager = filterManagerRef.current

  const handleClick = (_, row) => {
    const newModalData = {
      open: true,
      userId: row.user_id,
      email: row.user_email,
    }
    setModalData(newModalData)
  }

  const handleClose = () => {
    setModalData({ open: false })
  }

  useEffect(() => {
    if (usersData) {
      setProcessedUsers(
        usersData.map((user, index) => {
          return {
            ...filterManager.generateDataMap(
              undefined,
              undefined,
              undefined,
              undefined,
              undefined,
              undefined,
              user,
            ),
            id: index,
          }
        }),
      )
    }
  }, [usersData, filterManager.generateDataMap])

  return (
    <>
      <CustomTableContainer
        defaultOrder="desc"
        defaultOrderHeader={FILTER_TYPE.USER.ID}
        headers={filterManager.getHeaders()}
        filterManager={filterManager}
        rowData={processedUsers}
        paginationOptions={[5, 10, 25, 50, 100]}
        defaultPaginationOption={25}
        clickAction={handleClick}
      />

      {modalData?.userId && modalData.email && (
        <UserConfigModel
          userId={modalData.userId}
          open={modalData.open}
          handleClose={handleClose}
          email={modalData.email}
        />
      )}
    </>
  )
}
